var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiveTv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_715",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4444 19.3556L20.3111 15.6C20.4815 15.4815 20.6093 15.3445 20.6944 15.1889C20.7796 15.0333 20.8222 14.8593 20.8222 14.6667C20.8222 14.4741 20.7796 14.3 20.6944 14.1444C20.6093 13.9889 20.4815 13.8518 20.3111 13.7333L14.4444 9.97777C14.0741 9.73332 13.6963 9.71851 13.3111 9.93333C12.9259 10.1482 12.7333 10.4778 12.7333 10.9222V18.4111C12.7333 18.8555 12.9259 19.1852 13.3111 19.4C13.6963 19.6148 14.0741 19.6 14.4444 19.3556ZM12 28C11.6852 28 11.4213 27.8935 11.2083 27.6806C10.9954 27.4676 10.8889 27.2037 10.8889 26.8889V25.3333H4.88887C4.27776 25.3333 3.75462 25.1157 3.31944 24.6806C2.88426 24.2454 2.66667 23.7222 2.66667 23.1111V6.2222C2.66667 5.61109 2.88426 5.08794 3.31944 4.65277C3.75462 4.21759 4.27776 4 4.88887 4H27.1111C27.7222 4 28.2454 4.21759 28.6806 4.65277C29.1158 5.08794 29.3333 5.61109 29.3333 6.2222V23.1111C29.3333 23.7222 29.1158 24.2454 28.6806 24.6806C28.2454 25.1157 27.7222 25.3333 27.1111 25.3333H21.1111V26.8889C21.1111 27.2037 21.0046 27.4676 20.7917 27.6806C20.5787 27.8935 20.3148 28 20 28H12ZM4.88887 23.1111H27.1111V6.2222H4.88887V23.1111Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTv);
export default __webpack_public_path__ + "static/media/live_tv.decdeafa2d6f3bde2cc9569920ac1647.svg";
export { ForwardRef as ReactComponent };